import { useGetDashboardRedirectAction } from 'components-v2/dashboard-auto-redirect-wrapper/hooks/useGetDashboardRedirectAction';
import { useGetDashboardRedirectTimerConfig } from 'components-v2/dashboard-auto-redirect-wrapper/hooks/useGetDashboardRedirectTimerConfig';
import { useRouter } from 'next/router';
import React, { ReactNode, useEffect, useRef } from 'react';

export type DashboardAutoRedirectWrapperProps = {
  children: ReactNode;
  isAuthenticated?: boolean;
};

export const DashboardAutoRedirectWrapper = ({ children, isAuthenticated }: DashboardAutoRedirectWrapperProps) => {
  const router = useRouter();
  const { timer, excludes } = useGetDashboardRedirectTimerConfig();
  const { isLiveStream } = useGetDashboardRedirectAction({
    // Livestream will occur at home => need skip when at home & livestreaming
    isSkip: router.pathname !== '/home',
  });
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const isExcludes = !!excludes?.find((item: any) => router.pathname.includes(item));
    // Skip redirect when the current path is in the excludes list
    if (isExcludes) return;
    if (router.pathname === '/home' && isLiveStream) return;

    const setTimerRedirect = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(async () => {
        await router.push('/dashboard');
      }, timer);
    };

    const handleActivity = () => {
      // if (document.hidden) return; // Skip if tab is not active
      setTimerRedirect();
    };

    // Set initial timer
    setTimerRedirect();

    // Add activity listeners
    const events: string[] = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart', 'touchend'];
    events.forEach((event) => window.addEventListener(event, handleActivity));

    // // Visibility change handler
    // const handleVisibilityChange = () => {
    //   if (document.hidden) {
    //     // Clear timeout when the tab becomes inactive
    //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
    //   } else {
    //     // Reset the timer when the tab becomes active
    //     setTimerRedirect();
    //   }
    // };
    // document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup listeners
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      // document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [timer, isAuthenticated, isLiveStream, router.pathname, excludes]);

  return <div>{children}</div>;
};
